
export const HTTP_LOCAL_HOST_3000 = "http://localhost:3000";
export const HTTPS_LOCAL_HOST_3000 = "https://localhost:3000";
export const HTTP_LOCAL_HOST_5173 = "http://localhost:5173";
export const HTTPS_LOCAL_HOST_5173 = "https://localhost:5173";
export const DEV_TARGET_DMS_BASE_URL = "https://dev-targetdms.azurewebsites.net";
export const TEST_TARGET_DMS_BASE_URL = "https://test-targetdms.azurewebsites.net";
export const PROD_TARGET_DMS_BASE_URL = "https://dms.targetdealer.com";
export const DEV_TARGET_SERVICE_BASE_URL = "https://dev-garuda.azurewebsites.net";
export const TEST_TARGET_SERVICE_BASE_URL = "https://qa-garuda.azurewebsites.net";
export const TEST_TARGETCRM_EXP_BASE_URL = "https://targetcrmexp.z19.web.core.windows.net";
